module.exports = __webpack_public_path__ + "static/media/male01.79c2693c.jpg";